module.exports = __webpack_public_path__ + "img/Desktop-screenshot-p-500.9b1e24ff.png";